import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Profile from './Profile'
import Setting from './Setting'
import CreatePortfolio from './CreatePortfolio'
import ProfileCreation from './ProfileCreation'
import MarketPlaceCreation from './MarketPlaceCreation'
import ProfileOverView from './ProfileOverView'
import MarketPlaceDetail from './MarketPlaceDetail'
import MarketPlaceOverview from './MarketPlaceOverview'
import PortfolioSuccess from './PortfolioSuccess'

const MyProfile = () => {
    return (
        <div>
            <Routes>
                <Route path="/" element={<Profile />} />
                <Route path="/create-portfolio" element={<CreatePortfolio />} />
                <Route path="/porfile_creation" element={<ProfileCreation />} />
                <Route path="/profile_overview" element={<ProfileOverView />} />
                <Route path="/profile_success" element={<PortfolioSuccess />} />
                <Route path="/marketplace_creation" element={<MarketPlaceCreation />} />
                <Route path="/marketplace_details" element={<MarketPlaceDetail />} />
                <Route path="/marketplace_overview" element={<MarketPlaceOverview />} />
                <Route path="/setting" element={<Setting />} />
            </Routes>
        </div>
    )
}

export default MyProfile